import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';

class MyLearningPathPage extends Component{
    constructor(props) {
        super(props)
        this.state = {
            data:{
                certificationParticipationId: ''
            }
        }
    }

    render(){
        let mainPageContent = (
            <Grid>
                <GridCell span = "12">
                    <Card style={{padding: '25px'}}>
                        <Typography use="headline5">My Learning Path</Typography>
                    </Card>
                </GridCell>
                <GridCell span = "12">
                <Typography use="subtitle2">
                    Welcome to your Individual Learning Path! Here you will be able to mark a certain set of competencies as your strengths or areas of development, access the resources which you would have bookmarked for future reference and also see the list of resources you have archived.
                </Typography>
                <br />
                <Typography use="subtitle2">Click on the link below to view multiple sections of your learning path.</Typography>
                <List>
                    <ListItem>
                        <ListItemGraphic>assignment</ListItemGraphic>
                        <ListItemText><Link to="/portal/app/user/my_learning/strength_and_areas_of_development">My Strengths and Areas of Development </Link></ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemGraphic>bookmarks</ListItemGraphic>
                        <ListItemText><Link to="/portal/app/user/my_bookmarks_section">My Bookmarks</Link></ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemGraphic>how_to_vote</ListItemGraphic>
                        <ListItemText><Link to="/portal/app/user/my_archives_section">My Archives</Link></ListItemText>
                    </ListItem>
                </List>
                </GridCell>
            </Grid>
        )
        return(
            <div>
                {mainPageContent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLearningPathPage);


// WEBPACK FOOTER //
// ./src/views/roadmap/MyLearningPathPage.jsx